import { useRef } from 'react';

export function newIdempotencyKey(): string {
  const c = typeof globalThis !== 'undefined' ? globalThis.crypto : undefined;
  if (c && typeof c.randomUUID === 'function') return c.randomUUID();
  // Older browsers: RFC 4122 v4 from getRandomValues / Math.random.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, ch => {
    const r = Math.floor(Math.random() * 16);
    return (ch === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

/**
 * One key per user send action. `keyFor(signature)` returns the same key for the
 * same content (so a retry after an error is recognised as the same send by the
 * server) and a fresh key as soon as the content changes. Call `reset()` after a
 * successful send so the next message gets its own key.
 */
export function useIdempotencyKey() {
  const current = useRef<{ signature: string; key: string } | null>(null);
  return {
    keyFor(signature: string): string {
      if (!current.current || current.current.signature !== signature) {
        current.current = { signature, key: newIdempotencyKey() };
      }
      return current.current.key;
    },
    reset(): void {
      current.current = null;
    },
  };
}
